"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnixNow = void 0;
// Get the current time in unix in seconds
function getUnixNow() {
    return Math.floor(Date.now() / 1000);
}
exports.getUnixNow = getUnixNow;
